export default __webpack_public_path__ + "static/media/noBackground.edd1d31e.svg";